import { Card, Col, Input, Row } from 'antd';
import FormItem from 'components/form/FormItem';
import FormSelect from 'components/form/FormSelect';
import { BAN_REASONS } from 'constants/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Form = () => {
  const { t } = useTranslation();
  return (
    <Card className="mt-5">
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <FormSelect
            reference={{
              labelProp: 'name',
              valueProp: 'id',
              model: 'customers',
              searchMoreKeys: ['firstName', 'lastName', 'email', 'telephone'],
              allowClear: true,
              labelFormat: (e) =>
                `${e?.telephone} - ${e?.firstName || ''} ${e?.lastName || ''}`,
              // labelFormat: (e) =>
              //   `${e?.sku} - ${getDataDetail(e, 'detail', 'name', null)?.name}`,
            }}
            label={t('customers.customer')}
            name="customerId"
            required
          />
        </Col>
        <Col span={12}>
          <FormSelect
            name="reason"
            label={t('customers.reason')}
            options={BAN_REASONS}
          />
        </Col>
        <Col span={24}>
          <FormItem name="note" label={t('customers.note')}>
            <Input.TextArea />
          </FormItem>
        </Col>
      </Row>
    </Card>
  );
};

export default Form;
